module.exports = new __parcel__URL__("card_viper.c7caaa09.png").toString();